import { addressLine1 as addressLine1Filter, id as addressLine1FilterId } from './addressLine1';
import { addressLine2 as addressLine2Filter, id as addressLine2FilterId } from './addressLine2';
import { addressValidationStatus as addressValidationStatusFilter, id as addressValidationStatusFilterId } from './addressValidationStatus';
import { allocationStatus as allocationStatusFilter, id as allocationStatusFilterId } from './allocationStatus';
import { amountPaid as amountPaidFilter, id as amountPaidFilterId } from './amountPaid';
import { assignedTo as assignedToFilter, id as assignedToFilterId } from './assignedTo';
import { batchNumber as batchNumberFilter, id as batchNumberFilterId } from './batch-number';
import { buyerId as buyerIdFilter, id as buyerIdFilterId } from './buyerId';
import { buyerName as buyerNameFilter, id as buyerNameFilterId } from './buyerName';
import { carrier as carrierFilter, id as carrierFilterId } from './carrier';
import { city as cityFilter, id as cityFilterId } from './city';
import { company as companyFilter, id as companyFilterId } from './company';
import { country as countryFilter, id as countryFilterId } from './country';
import { createdBy as createdByFilter, id as createdByFilterId } from './created-by';
import { createdDate as createdDateFilter, id as createdDateFilterId } from './created-date';
import { createdDateTime as createdDateTimeFilter, id as createdDateTimeFilterId } from './created-date-time';
import { customer as customerFilter, id as customerFilterId } from './customer';
import { customField1 as customField1Filter, id as customField1FilterId } from './customField1';
import { customField2 as customField2Filter, id as customField2FilterId } from './customField2';
import { customField3 as customField3Filter, id as customField3FilterId } from './customField3';
import { datePaid as datePaidFilter, id as datePaidFilterId } from './datePaid';
import { delegationDate as delegationDateFilter, id as delegationDateFilterId } from './delegation-date';
import { deliverByDate as deliverByDateFilter, id as deliverByDateFilterId } from './deliver-by-date';
import { deliveryStatus, id as deliveryStatusFilterId } from './delivery-status';
import { deliveryStatusAsCollection, id as deliveryStatusAsCollectionFilterId } from './delivery-status/delivery-status-as-collection';
import { deliveryEmailSent as deliveryEmailSentFilter, id as deliveryEmailSentFilterId } from './deliveryEmailSent';
import { destination as destinationFilter, id as destinationFilterId } from './destination';
import { email as emailFilter, id as emailFilterId } from './email';
import { externalStatus as externalStatusFilter, id as externalStatusFilterId } from './external-status';
import { fulfillmentProvider as fulfillmentProviderFilter, id as fulfillmentProviderFilterId } from './fulfillment-provider';
import { fulfillmentType, id as fulfillmentTypeFilterId } from './fulfillment-type';
import { gift as giftFilter, id as giftFilterId } from './gift';
import { insurance as insuranceFilter, id as insuranceFilterId } from './insurance';
import { insuranceFee as insuranceFeeFilter, id as insuranceFeeFilterId } from './insurance-fee';
import { internalNotes as internalNotesFilter, id as internalNotesFilterId } from './internalNotes';
import { isDomestic, id as isDomesticFilterId } from './is-domestic';
import { isShipped as isShippedFilter, id as isShippedFilterId } from './is-shipped';
import { isVoided as isVoidedFilter, id as isVoidedFilterId } from './is-voided';
import { itemName as itemNameFilter, id as itemNameFilterId } from './item-name';
import { itemOption as itemOptionFilter, id as itemOptionFilterId } from './item-option';
import { itemSku as itemSkuFilter, id as itemSkuFilterId } from './item-sku';
import { labelPrinted as isLabelPrintedFilter, id as isLabelPrintedFilterId } from './label-printed';
import { lineItems as lineItemsFilter, id as lineItemsFilterId } from './lineItems';
import { marketplace as marketplaceFilter, id as marketplaceFilterId } from './marketplace';
import { marketplaceNotification as marketplaceNotificationFilter, id as marketplaceNotificationFilterId } from './marketplaceNotification';
import { notes as noteFilter, id as noteFilterId } from './notes';
import { notesFromBuyer as notesFromBuyerFilter, id as notesFromBuyerFilterId } from './notesFromBuyer';
import { notesToBuyer as notesToBuyerFilter, id as notesToBuyerFilterId } from './notesToBuyer';
import { orderDate as orderDateFilter, id as orderDateFilterId } from './order-date';
import { orderNumber as orderNumberFilter, id as orderNumberFilterId } from './order-number';
import { orderStatus, id as orderStatusFilterId } from './order-status';
import { orderSubtotal as orderSubtotalFilter, id as orderSubtotalFilterId } from './orderSubtotal';
import { orderTotal as orderTotalFilter, id as orderTotalFilterId } from './orderTotal';
import { packageFilter, id as packageFilterId } from './package';
import { packingSlip as packingSlipFilter, id as packingSlipFilterId } from './packing-slip';
import { warehouseStatus as warehouseStatusFilter, id as warehouseStatusFilterId } from './warehouse-status';
import { pickingExceptionFilter, id as pickingExceptionFilterId } from './picking-exception';
import { pickList as pickListFilter, id as pickListFilterId } from './pick-list';
import { paymentMethod as paymentMethodFilter, id as paymentMethodFilterId } from './paymentMethod';
import { postalCode as postalCodeFilter, id as postalCodeFilterId } from './postalCode';
import { processedDateTime, id as processedDateTimeId } from './processed-date-time';
import { provider as providerFilter, id as providerFilterId } from './provider';
import { rate as rateFilter, id as rateFilterId } from './rate';
import { recipientName as recipientNameFilter, id as recipientNameFilterId } from './recipient-name';
import { requestedServiceMapped as requestedServiceMappedFilter, id as requestedServiceMappedFilterId } from './requestedServiceMapped';
import {
  requestedServiceMarketplace as requestedServiceMarketplaceFilter,
  id as requestedServiceMarketplaceFilterId,
} from './requestedServiceMarketplace';
import { residentialOrCommercial as residentialOrCommercialFilter, id as residentialOrCommercialFilterId } from './residentialOrCommercial';
import { returnReceived as returnReceivedFilter, id as returnReceivedFilterId } from './return-received';
import { returningParty as returningPartyFilter, id as returningPartyFilterId } from './returning-party';
import { rmaNumber as rmaNumberFilter, id as rmaNumberFilterId } from './rma-number';
import { sellerBrand as sellerBrandFilter, id as sellerBrandFilterId } from './seller-brand';
import { service as serviceFilter, id as serviceFilterId } from './service';
import { rateShopper as rateShopperFilter, id as rateShopperFilterId } from './rate-shopper';
import { shipDate as shipDateFilter, id as shipDateFilterId } from './ship-date';
import { shipFrom as shipFromFilter, id as shipFromFilterId } from './ship-from';
import { shipByDate as shipByDateFilter, id as shipByDateFilterId } from './shipByDate';
import { shipmentNumber as shipmentNumberFilter, id as shipmentNumberFilterId } from './shipment-number';
import { shipmentNotification as shipmentNotificationFilter, id as shipmentNotificationFilterId } from './shipmentNotification';
import { shippingAccount as shippingAccountFilter, id as shippingAccountFilterId } from './shippingAccount';
import { shippingBillToParty as shippingBillToPartyFilter, id as shippingBillToPartyFilterId } from './shippingBillToParty';
import { shippingPaid as shippingPaidFilter, id as shippingPaidFilterId } from './shippingPaid';
import { source, id as sourceFilterId } from './source';
import { state as stateFilter, id as stateFilterId } from './state';
import { store as storeFilter, id as storeFilterId } from './store';
import { submissionDate as submissionDateFilter, id as submissionDateFilterId } from './submission-date';
import { tag, id as tagFilterId } from './tag';
import { taxPaid as taxPaidFilter, id as taxPaidFilterId } from './taxPaid';
import { totalQuantity as totalQuantityFilter, id as totalQuantityFilterId } from './totalQuantity';
import { trackingNumber as trackingNumberFilter, id as trackingNumberFilterId } from './tracking-number';
import { warehouse as warehouseFilter, id as warehouseFilterId } from './warehouse';
import { weight as weightFilter, id as weightFilterId } from './weight';
import { zone as zoneFilter, id as zoneFilterId } from './zone';
import { tote as toteFilter, id as toteFilterId } from './tote';

export const options = {
  [addressLine1FilterId]: addressLine1Filter,
  [addressLine2FilterId]: addressLine2Filter,
  [addressValidationStatusFilterId]: addressValidationStatusFilter,
  [allocationStatusFilterId]: allocationStatusFilter,
  [amountPaidFilterId]: amountPaidFilter,
  [assignedToFilterId]: assignedToFilter,
  [batchNumberFilterId]: batchNumberFilter,
  [buyerIdFilterId]: buyerIdFilter,
  [buyerNameFilterId]: buyerNameFilter,
  [carrierFilterId]: carrierFilter,
  [cityFilterId]: cityFilter,
  [companyFilterId]: companyFilter,
  [countryFilterId]: countryFilter,
  [createdByFilterId]: createdByFilter,
  [createdDateFilterId]: createdDateFilter,
  [createdDateTimeFilterId]: createdDateTimeFilter,
  [customField1FilterId]: customField1Filter,
  [customField2FilterId]: customField2Filter,
  [customField3FilterId]: customField3Filter,
  [customerFilterId]: customerFilter,
  [datePaidFilterId]: datePaidFilter,
  [delegationDateFilterId]: delegationDateFilter,
  [deliverByDateFilterId]: deliverByDateFilter,
  [deliveryEmailSentFilterId]: deliveryEmailSentFilter,
  [deliveryStatusAsCollectionFilterId]: deliveryStatusAsCollection,
  [deliveryStatusFilterId]: deliveryStatus,
  [destinationFilterId]: destinationFilter,
  [emailFilterId]: emailFilter,
  [externalStatusFilterId]: externalStatusFilter,
  [fulfillmentProviderFilterId]: fulfillmentProviderFilter,
  [fulfillmentTypeFilterId]: fulfillmentType,
  [giftFilterId]: giftFilter,
  [insuranceFilterId]: insuranceFilter,
  [insuranceFeeFilterId]: insuranceFeeFilter,
  [internalNotesFilterId]: internalNotesFilter,
  [isDomesticFilterId]: isDomestic,
  [isLabelPrintedFilterId]: isLabelPrintedFilter,
  [isShippedFilterId]: isShippedFilter,
  [isVoidedFilterId]: isVoidedFilter,
  [itemNameFilterId]: itemNameFilter,
  [itemOptionFilterId]: itemOptionFilter,
  [itemSkuFilterId]: itemSkuFilter,
  [lineItemsFilterId]: lineItemsFilter,
  [marketplaceFilterId]: marketplaceFilter,
  [marketplaceNotificationFilterId]: marketplaceNotificationFilter,
  [noteFilterId]: noteFilter,
  [notesFromBuyerFilterId]: notesFromBuyerFilter,
  [notesToBuyerFilterId]: notesToBuyerFilter,
  [orderDateFilterId]: orderDateFilter,
  [orderNumberFilterId]: orderNumberFilter,
  [orderStatusFilterId]: orderStatus,
  [orderSubtotalFilterId]: orderSubtotalFilter,
  [orderTotalFilterId]: orderTotalFilter,
  [packageFilterId]: packageFilter,
  [packingSlipFilterId]: packingSlipFilter,
  [pickingExceptionFilterId]: pickingExceptionFilter,
  [pickListFilterId]: pickListFilter,
  [paymentMethodFilterId]: paymentMethodFilter,
  [postalCodeFilterId]: postalCodeFilter,
  [processedDateTimeId]: processedDateTime,
  [providerFilterId]: providerFilter,
  [rateFilterId]: rateFilter,
  [recipientNameFilterId]: recipientNameFilter,
  [requestedServiceMappedFilterId]: requestedServiceMappedFilter,
  [requestedServiceMarketplaceFilterId]: requestedServiceMarketplaceFilter,
  [residentialOrCommercialFilterId]: residentialOrCommercialFilter,
  [returnReceivedFilterId]: returnReceivedFilter,
  [returningPartyFilterId]: returningPartyFilter,
  [rmaNumberFilterId]: rmaNumberFilter,
  [sellerBrandFilterId]: sellerBrandFilter,
  [serviceFilterId]: serviceFilter,
  [rateShopperFilterId]: rateShopperFilter,
  [shipByDateFilterId]: shipByDateFilter,
  [shipDateFilterId]: shipDateFilter,
  [shipFromFilterId]: shipFromFilter,
  [shipmentNotificationFilterId]: shipmentNotificationFilter,
  [shipmentNumberFilterId]: shipmentNumberFilter,
  [shippingAccountFilterId]: shippingAccountFilter,
  [shippingBillToPartyFilterId]: shippingBillToPartyFilter,
  [shippingPaidFilterId]: shippingPaidFilter,
  [sourceFilterId]: source,
  [stateFilterId]: stateFilter,
  [storeFilterId]: storeFilter,
  [submissionDateFilterId]: submissionDateFilter,
  [tagFilterId]: tag,
  [taxPaidFilterId]: taxPaidFilter,
  [totalQuantityFilterId]: totalQuantityFilter,
  [trackingNumberFilterId]: trackingNumberFilter,
  [warehouseFilterId]: warehouseFilter,
  [warehouseStatusFilterId]: warehouseStatusFilter,
  [weightFilterId]: weightFilter,
  [zoneFilterId]: zoneFilter,
  [toteFilterId]: toteFilter,
};
